import {motion} from 'framer-motion'
import {createPortal} from 'react-dom'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'

import Icon from '@/components/Icon'

const ModalWrapper = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 150;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`

const ModalDialog = styled(motion.div)`
  position: relative;
  background-color: white;
  border-radius: 1rem;
  padding: 2rem;
  max-width: 480px;
  width: 90%;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
`

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid #ddd;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }

  svg {
    width: 1rem;
    height: 1rem;
    fill: #666;
  }
`

const EInvoiceContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 0.5rem;

  h3 {
    margin-bottom: 1.5rem;
    margin-top: 0;
    font-size: 1.1rem;
    color: ${props => props.theme.colors.global};
    padding: 0 2.5rem;
    line-height: 1.3;
  }

  img {
    width: 180px;
    height: 180px;
    margin-bottom: 1rem;
  }

  p {
    font-size: 0.85rem;
    color: #666;
    margin: 0;
  }
`

const ConfirmationEInvoiceModal = props => {
  const {onClose, image} = props
  const {t} = useTranslation()

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return createPortal(
    <ModalWrapper
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      transition={{duration: 0.2}}
      onClick={handleBackdropClick}
    >
      <ModalDialog
        initial={{scale: 0.9, opacity: 0}}
        animate={{scale: 1, opacity: 1}}
        exit={{scale: 0.9, opacity: 0}}
        transition={{duration: 0.2}}
      >
        <CloseButton onClick={onClose}>
          <Icon name="close"/>
        </CloseButton>
        <EInvoiceContent>
          <h3>{t('getEInvoice')}</h3>
          <img src={`data:image/png;base64,${image}`} alt="E-Invoice QR Code"/>
          <p>{t('scanQRCode')}</p>
        </EInvoiceContent>
      </ModalDialog>
    </ModalWrapper>,
    document.querySelector('#modal') || document.body
  )
}

export default ConfirmationEInvoiceModal
